import '../sass/styles.scss';
import $ from 'jquery';

$(document).ready(function () {
    console.log('theme ready');
});